var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 58.6484C13.0136 58.6484 0 45.6377 0 29.6548C0 13.672 13.0009 0.648438 29 0.648438C44.9863 0.648438 58 13.6592 58 29.6421C58 45.6249 44.9863 58.6484 29 58.6484ZM29 2.54903C14.0598 2.54903 1.90102 14.7052 1.90102 29.6421C1.90102 44.5789 14.0598 56.7351 29 56.7351C43.9402 56.7351 56.099 44.5789 56.099 29.6421C56.099 14.7052 43.9402 2.54903 29 2.54903Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4076 23.864C37.3438 23.864 37.2928 23.8768 37.2418 23.9023V22.9074C37.2418 21.0705 35.749 19.5781 33.9118 19.5781H23.2968C21.4595 19.5781 19.9668 21.0705 19.9668 22.9074V36.1477C19.9668 37.9845 21.4595 39.477 23.2968 39.477H33.9118C35.749 39.477 37.2418 37.9845 37.2418 36.1477V35.2931C37.2545 35.2931 37.2545 35.3059 37.2673 35.3059C37.3821 35.3059 37.4842 35.2166 37.4842 35.089V29.8592C37.4842 29.7444 37.3949 29.6423 37.2673 29.6423C37.2545 29.6423 37.2545 29.6551 37.2418 29.6551V27.6907C37.2928 27.7035 37.3438 27.729 37.4076 27.729C37.7521 27.729 38.02 27.4484 38.02 27.1167V24.4891C38.02 24.1447 37.7394 23.864 37.4076 23.864Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3396 17.8185H21.7773L22.479 13.6219C22.6704 12.4484 23.6911 11.5938 24.8649 11.5938H32.2393C33.4258 11.5938 34.4337 12.4484 34.6251 13.6219L35.3396 17.8185Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3396 41.2344H21.7773L22.479 45.431C22.6704 46.6045 23.6911 47.4591 24.8649 47.4591H32.2393C33.4258 47.4591 34.4337 46.6045 34.6251 45.431L35.3396 41.2344Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIwatch);
export default __webpack_public_path__ + "static/media/iwatch.cbc65324384157017505a9c023a5f4d8.svg";
export { ForwardRef as ReactComponent };